import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { backendApi, usePostAuthLogoutMutation } from '../../store/backendApi';

/**
 * Platform-agnostic hook for handling sign out logic.
 * Triggers logout mutation, clears RTK cache, and tracks completion state.
 */
export function useSignOut() {
  const dispatch = useDispatch();
  const [signOutAction, { data, isLoading }] = usePostAuthLogoutMutation();

  useEffect(() => {
    const performSignOut = async () => {
      // Call the logout API
      await signOutAction();

      // Clear all RTK Query cache after logout
      dispatch(backendApi.util.resetApiState());
    };

    performSignOut();
  }, [signOutAction, dispatch]);

  return {
    isComplete: !!data,
    isLoading,
  };
}
